import { FC, useEffect } from 'react';
import { Container, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { observer } from "mobx-react";
import store from "./store";
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import PopupGrid from 'components/PopupGrid';
import DepartmentPopupForm from 'features/Department/DepartmentAddEditView/popupForm';
import CustomButton from 'components/Button';

type DepartmentListViewProps = {
  idMain: number;
};

const DepartmentListView: FC<DepartmentListViewProps> = observer((props) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (store.idMain !== props.idMain) {
      store.idMain = props.idMain;
    }
    store.loaddepartments();
    return () => store.clearStore();
  }, [props.idMain]);

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Название',
      flex: 2,
      renderCell: (param) => <div>{param.row.name}</div>,
    },
    {
      field: 'description',
      headerName: 'Описание',
      flex: 3,
      renderCell: (param) => <div>{param.row.description}</div>,
    },
    {
      field: 'is_active',
      headerName: 'Активен',
      flex: 1,
      renderCell: (param) => <div>{param.row.is_active ? 'Да' : 'Нет'}</div>,
    },
  ];

  return (
    <Container maxWidth='xl' sx={{ mt: 4 }}>
      <PopupGrid
        title="Отделы"
        onDeleteClicked={(id: number) => store.deletedepartment(id)}
        onEditClicked={(id: number) => store.onEditClicked(id)}
        columns={columns}
        hideAddButton
        customBottom={
          <Box>
            <CustomButton
              variant='contained'
              sx={{ mb: 1 }}
              id="departmentAddButton"
              onClick={() => store.onEditClicked(0)}
              endIcon={<AddIcon />}
            >
              {t('add')}
            </CustomButton>
          </Box>
        }
        data={store.data}
        tableName="department"
      />

      <DepartmentPopupForm
        openPanel={store.openPanel}
        id={store.currentId}
        onBtnCancelClick={() => store.closePanel()}
        onSaveClick={() => {
          store.closePanel();
          store.loaddepartments();
        }}
      />
    </Container>
  );
});

export default DepartmentListView;
